<template>
	<div>
		<div class="timeline-2">
			<div class="timeline-2_row __header">
				<div class="timeline-2_name"></div>
				
				<div class="timeline-2_score" v-if="match.home_score || match.away_score">С</div>
				
				<div class="timeline-2_value" v-if="match.results.set1">1</div>
				<div class="timeline-2_value" v-if="match.results.set2">2</div>
				<div class="timeline-2_value" v-if="match.results.set3">3</div>
				<div class="timeline-2_value" v-if="match.results.set4">4</div>
				<div class="timeline-2_value" v-if="match.results.set5">5</div>
			</div>
			<div class="timeline-2_row">
				<div class="timeline-2_name" :class="isHomeWin()">{{ match.home_name }}</div>
				
				<div class="timeline-2_score" :class="isHomeWin()">{{ match.home_score }}</div>
				
				<div class="timeline-2_value" v-if="match.results.set1" :class="isSetWin(match.results.set1.home, match.results.set1.away)">
					{{ match.results.set1.home }}
				</div>
				<div class="timeline-2_value" v-if="match.results.set2" :class="isSetWin(match.results.set2.home, match.results.set2.away)">
					{{ match.results.set2.home }}
				</div>
				<div class="timeline-2_value" v-if="match.results.set3" :class="isSetWin(match.results.set3.home, match.results.set3.away)">
					{{ match.results.set3.home }}
				</div>
				<div class="timeline-2_value" v-if="match.results.set4" :class="isSetWin(match.results.set4.home, match.results.set4.away)">
					{{ match.results.set4.home }}
				</div>
				<div class="timeline-2_value" v-if="match.results.set5" :class="isSetWin(match.results.set5.home, match.results.set5.away)">
					{{ match.results.set5.home }}
				</div>
			</div>
			<div class="timeline-2_row">
				<div class="timeline-2_name" :class="isAwayWin()">{{ match.away_name }}</div>
				
				<div class="timeline-2_score" :class="isAwayWin()">{{ match.away_score }}</div>
				
				<div class="timeline-2_value" v-if="match.results.set1" :class="isSetWin(match.results.set1.away, match.results.set1.home)">
					{{ match.results.set1.away }}
				</div>
				<div class="timeline-2_value" v-if="match.results.set2" :class="isSetWin(match.results.set2.away, match.results.set2.home)">
					{{ match.results.set2.away }}
				</div>
				<div class="timeline-2_value" v-if="match.results.set3" :class="isSetWin(match.results.set3.away, match.results.set3.home)">
					{{ match.results.set3.away }}
				</div>
				<div class="timeline-2_value" v-if="match.results.set4" :class="isSetWin(match.results.set4.away, match.results.set4.home)">
					{{ match.results.set1.away }}
				</div>
				<div class="timeline-2_value" v-if="match.results.set5" :class="isSetWin(match.results.set5.away, match.results.set5.home)">
					{{ match.results.set5.away }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['match'],
		
		methods: {
			isHomeWin() {
				return {
					__bold: Number(this.match.home_score) > Number(this.match.away_score)
				}
			},
			isAwayWin() {
				return {
					__bold: Number(this.match.home_score) < Number(this.match.away_score)
				}
			},
			isSetWin(set1, set2) {
				return {
					__bold: Number(set1) > Number(set2)
				}
			}
		}
	}
</script>

<style scoped>

</style>